import { Request,BaseApiUrl } from "./api";

// 列表
export const getVehicleListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/Vehicle/get`, { params: params });
};


//新增
export const addVehicle = (params) => {
  return Request.post(`${BaseApiUrl}/api/Vehicle/Post`, params);
};
//编辑
export const editVehicle = (params) => {
  return Request.post(`${BaseApiUrl}/api/Vehicle/Put`, params);
};

//删除
export const removeVehicle = (params) => {
  return Request.post(`${BaseApiUrl}/api/Vehicle/Put`, params);
};

// 获取当班司机
export const getVehicleWorker = (params) => {
  return Request.get(`${BaseApiUrl}/api/VehicleWorker/get`, { params: params });
};

// 保存当班司机
export const postVehicleWorker = (params) => {
  return Request.post(`${BaseApiUrl}/api/VehicleWorker/Post`, params);
};

//批量删除当班司机
export const batchDeleteVehicleWorker = (params) => {
  return Request.post(`${BaseApiUrl}/api/VehicleWorker/BatchDelete`, params);
};
// export const batchDeleteVehicleWorker = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/VehicleWorker/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
//批量删除
export const batchDeleteVehicle = (params) => {
  return Request.post(`${BaseApiUrl}/api/Vehicle/BatchDelete`, params);
};
// export const batchDeleteVehicle = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/Vehicle/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
// 列表
export const getVehicleDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Vehicle/Detail`, { params: params });
};

